import PropTypes from "prop-types";
import parse from "html-react-parser";
import { Copy } from "components/Copy";
import { CopyIcon } from "components/Icons/CopyIcon";
import { formatDate } from "utils/date";
import { ContainerViewStake } from "../../../components/Container";
import { WithdrawFormContainer } from "../../stake-sgt/styles";
import { SuccessGradient } from "../../../components/Icons/SuccessGradient";
import { AntButton } from "components/AntButton";

export const ClaimStakeSuccessScreen = ({
  T,
  claimAmount,
  claimDate,
  transactionHash,
  onPrimaryAction,
}) => {

  return (
    <ContainerViewStake>
      <WithdrawFormContainer>
        <div className="flex flex-col items-center gap-[30px] lg:gap-[50px]">
          <div className="text-[24px] lg:text-[36px] leading-[32px] lg:leading-[44px] text-center text-[#000000] font-semibold">
            {T("Claim in progress")}
          </div>

          <div className="flex justify-center items-center">
            <SuccessGradient className={"w-[52px] lg:w-[80px]"} />
          </div>

          <div className="px-4 lg:px-32 w-full">
            <div className="grid grid-cols-[210px_1fr] md:grid-cols-[250px_1fr] gap-y-2.5 max-w-[372px] mx-auto">
              <div className="text-[16px] leading-[25px] text-black">
                {T("Claim amount")}
              </div>
              <div className="text-[16px] leading-[25px] text-black">
                {claimAmount}
              </div>

              <div className="text-[16px] leading-[25px] text-black">
                {T("Claim date")}
              </div>
              <div className="text-[16px] leading-[25px] text-black">
                {formatDate(claimDate)}
              </div>

              <div className="text-[16px] leading-[25px] text-black">
                {T("Transaction hash")}
              </div>
              <div className="text-[16px] leading-[25px] text-black">
                <div className="flex items-center gap-2">
                  {transactionHash && (
                    <Copy
                      textStyle={{ fontWeight: 400 }}
                      className="justify-start gap-3"
                      cutText={true}
                      splitFont={6}
                      splitFontLg={6}
                      numDot={4}
                      text={transactionHash}
                      icon={<CopyIcon />}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="text-center text-[16px] leading-[25px] text-black max-w-[700px]">
            <p className="mb-2">{parse(T("claim_inprogress_description"))}</p>
          </div>

          <div className="flex justify-center items-center">
            <AntButton
              variant="primary"
              onClick={onPrimaryAction}
            >
              {T("Back to Home")}
            </AntButton>
          </div>
        </div>
      </WithdrawFormContainer>
    </ContainerViewStake>
  );
};

ClaimStakeSuccessScreen.propTypes = {
  T: PropTypes.func.isRequired,
  claimAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  claimDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
    .isRequired,
  transactionHash: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onPrimaryAction: PropTypes.func.isRequired,
};
